export const areStringArraysEqualUnordered = (
    a: string[],
    b: string[],
): boolean => {
    if (a === b) return true;
    if (a.length !== b.length) return false;

    const setA = new Set(a);
    if (setA.size !== b.length) return false;

    for (const value of b) {
        if (!setA.has(value)) {
            return false;
        }
    }

    return true;
};
